import { render, staticRenderFns } from "./workflowSopAssignment.vue?vue&type=template&id=ded0f7f2&"
import script from "./workflowSopAssignment.vue?vue&type=script&lang=js&"
export * from "./workflowSopAssignment.vue?vue&type=script&lang=js&"
import style0 from "./workflowSopAssignment.vue?vue&type=style&index=0&id=ded0f7f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports